import styled from 'styled-components'

export const ErrorMessage = styled.span`
  color: ${({ theme }) => theme.colours.red[30]};
  font-size: 12px;
`
